module.exports = __webpack_public_path__ + "static/media/richard_avila_saxophone_instructor.39a73a37.jpg";